module.exports = __webpack_public_path__ + "img/flame.6619cd85.svg";